/* LiberNovo collection landing — series switcher + decision quiz.
   Recommendation logic + product data come from the [data-lnxc-data] island,
   so the quiz always points at a real product page. */
(function () {
  function init(root) {
    if (!root || root.__lnxcInit) return;
    root.__lnxcInit = true;

    var data = {};
    var dataEl = root.querySelector('[data-lnxc-data]');
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { products: {} }; }
    var P = data.products || {};

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    // Titlul si subtitlul seriei vin din insula de date, traduse de Liquid. Aici erau
    // scrise de mana, in romana, cu termene de livrare care au ramas in urma stocului.
    var LINEUP = data.lineup || {};

    // ---- smooth scroll (hero buttons) ----
    $$('[data-lnxc-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var el = document.getElementById(b.getAttribute('data-lnxc-scroll'));
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
      });
    });

    // ---- series switcher ----
    function setSeries(series) {
      $$('[data-lnxc-seg]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-series') === series ? 'true' : 'false');
      });
      $$('[data-lnxc-series-card]').forEach(function (c) {
        c.setAttribute('data-active', c.getAttribute('data-series') === series ? 'true' : 'false');
      });
      $$('.lnxc-prod').forEach(function (card) {
        if (card.getAttribute('data-series') === series) card.removeAttribute('hidden');
        else card.setAttribute('hidden', '');
      });
      var t = $('[data-lnxc-lineup-title]'); if (t && LINEUP[series]) t.textContent = LINEUP[series].title;
      var s = $('[data-lnxc-lineup-sub]'); if (s && LINEUP[series]) s.textContent = LINEUP[series].sub;
    }
    $$('[data-lnxc-seg]').forEach(function (b) {
      b.addEventListener('click', function () { setSeries(b.getAttribute('data-series')); });
    });
    $$('[data-lnxc-series-card]').forEach(function (c) {
      c.addEventListener('click', function () {
        setSeries(c.getAttribute('data-series'));
        var el = document.getElementById('lineup');
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
      });
    });

    // ---- decision quiz ----
    var state = { q1: null, q2: null, q3: null };

    function recommend() {
      var q1 = state.q1, q2 = state.q2, q3 = state.q3, id;
      if (q1 === 'tall') {
        id = (q2 === 'cool' || q3 === 'high') ? 'maxis-airflow' : (q3 === 'low' ? 'maxis-manual' : 'maxis-electric');
      } else if (q1 === 'std') {
        id = (q3 === 'low') ? 'omni-se' : (q2 === 'support' ? 'omni-pro' : 'omni');
      } else {
        id = (q2 === 'cool') ? 'maxis-airflow' : (q3 === 'low' ? 'omni-se' : 'omni-pro');
      }
      var p = P[id];
      if (!p) return;
      var nameEls = [$('[data-lnxc-rec-name]'), $('[data-lnxc-rec-name2]')];
      nameEls.forEach(function (e) { if (e) e.textContent = p.name; });
      var why = $('[data-lnxc-rec-why]'); if (why) why.textContent = p.why;
      var img = $('[data-lnxc-rec-img]'); if (img) img.src = p.img;
      var cta = $('[data-lnxc-rec-cta]'); if (cta) cta.setAttribute('href', p.url);
    }

    $$('.lnxc-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-q'), v = btn.getAttribute('data-v');
        state[q] = v;
        $$('.lnxc-opt[data-q="' + q + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        recommend();
      });
    });

    // ---- video showcase: scroll arrows + autoplay-on-scroll (muted, reduced-motion safe) ----
    var showRow = $('[data-lnxc-show-row]');
    var sp = $('[data-lnxc-show-prev]'); if (sp && showRow) sp.addEventListener('click', function () { showRow.scrollBy({ left: -Math.round(showRow.clientWidth * 0.8), behavior: 'smooth' }); });
    var sn = $('[data-lnxc-show-next]'); if (sn && showRow) sn.addEventListener('click', function () { showRow.scrollBy({ left: Math.round(showRow.clientWidth * 0.8), behavior: 'smooth' }); });
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autovids = $$('[data-lnxc-autoplay]');
    if (autovids.length && 'IntersectionObserver' in window && !reduced) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && en.intersectionRatio >= 0.4) {
            if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.4, 0.75] });
      autovids.forEach(function (v) { vio.observe(v); });
    }

    // ---- click/keyboard a showcase clip → open it fullscreen, with sound ----
    var vlb = $('[data-lnxc-vlb]');
    var vlbVideo = vlb && vlb.querySelector('[data-lnxc-vlb-video]');
    if (vlb && vlbVideo) {
      var lastFocus = null;
      function resumeGrid() { if (reduced) return; autovids.forEach(function (v) { var pr = v.play && v.play(); if (pr && pr.catch) pr.catch(function () {}); }); }
      function openVlb(src, cap) {
        if (!src) return;
        lastFocus = document.activeElement;
        autovids.forEach(function (v) { if (!v.paused) v.pause(); });
        vlbVideo.src = src;
        if (cap) vlbVideo.setAttribute('aria-label', cap);
        vlbVideo.muted = false;
        vlb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        try { vlbVideo.currentTime = 0; } catch (e) {}
        var pr = vlbVideo.play(); if (pr && pr.catch) pr.catch(function () {});
        var rf = vlb.requestFullscreen || vlb.webkitRequestFullscreen || vlb.msRequestFullscreen;
        if (rf) { try { var fp = rf.call(vlb); if (fp && fp.catch) fp.catch(function () {}); } catch (e) {} }
        var cb = vlb.querySelector('[data-lnxc-vlb-close]'); if (cb) cb.focus();
      }
      function closeVlb() {
        if (vlb.hidden) return;
        vlb.hidden = true;
        try { vlbVideo.pause(); } catch (e) {}
        vlbVideo.removeAttribute('src'); vlbVideo.load();
        document.documentElement.style.overflow = '';
        var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        if (fsEl) { try { (document.exitFullscreen || document.webkitExitFullscreen).call(document); } catch (e) {} }
        resumeGrid();
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      }
      $$('[data-lnxc-vopen]').forEach(function (card) {
        card.addEventListener('click', function () { openVlb(card.getAttribute('data-vsrc'), card.getAttribute('data-vcap')); });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); openVlb(card.getAttribute('data-vsrc'), card.getAttribute('data-vcap')); }
        });
      });
      var cbtn = vlb.querySelector('[data-lnxc-vlb-close]');
      if (cbtn) cbtn.addEventListener('click', closeVlb);
      vlb.addEventListener('click', function (e) { if (e.target === vlb) closeVlb(); });
      document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !vlb.hidden) closeVlb(); });
      function onFsChange() { var el = document.fullscreenElement || document.webkitFullscreenElement; if (!el && !vlb.hidden) closeVlb(); }
      document.addEventListener('fullscreenchange', onFsChange);
      document.addEventListener('webkitfullscreenchange', onFsChange);
    }
  }

  function boot() { document.querySelectorAll('[data-lnxc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
